import { render, staticRenderFns } from "./ScreenerWidget.vue?vue&type=template&id=6876ab64&scoped=true&"
import script from "./ScreenerWidget.vue?vue&type=script&lang=js&"
export * from "./ScreenerWidget.vue?vue&type=script&lang=js&"
import style0 from "./ScreenerWidget.vue?vue&type=style&index=0&id=6876ab64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6876ab64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../var/www/html/film-screening-production/avails/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VFlex,VImg,VLayout})
